var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-item-tpl', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('round-button', {
    attrs: {
      "type": _vm.typeClass,
      "font-size": 24
    }
  }, [_vm._v(_vm._s(_vm.firstLetter))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "line-text-1"
  }, [_vm._v(_vm._s(_vm.item.linkman))]), _vm._v(" "), _c('p', {
    staticClass: "line-text-2"
  }, [_vm._v(_vm._s(_vm.getSourceName(_vm.item.companyAbbr)))])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('p-icon', {
    staticClass: "line-text-1",
    attrs: {
      "icon-name": "phone"
    }
  }, [_vm._v(_vm._s(_vm.item.tel))]), _vm._v(" "), _c('p-icon', {
    staticClass: "line-text-2",
    attrs: {
      "icon-name": "email"
    }
  }, [_vm._v(_vm._s(_vm.item.email))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('p-icon', {
    staticClass: "line-text-1",
    attrs: {
      "icon-name": "list"
    }
  }, [_vm._v(_vm._s(_vm.item.companyFullName))]), _vm._v(" "), _c('p-icon', {
    staticClass: "line-text-2",
    attrs: {
      "icon-name": "clock"
    }
  }, [_vm._v(_vm._s(_vm.item.createTime))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('edit', _vm.item)
      }
    }
  }, [_vm._v("\n                修改公司信息\n            ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'supplierUsers',
        query: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("修改人员信息")])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.remove(_vm.item.id)
      }
    }
  }, [_vm._v("删除当前数据")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "supplier-bottom",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("跟进HR：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.applicant))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("签约部门：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.projectName))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('label', [_vm._v("备注：")]), _vm._v(" "), _c('span', [(_vm.item.remark && _vm.item.remark.length > 30) ? _c('span', [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.item.remark,
      "placement": "top-start"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.remark.slice(0, 30)) + "...")])])], 1) : _c('span', [_vm._v("\n                    " + _vm._s(_vm.item.remark) + "\n                ")])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-927fe284"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/supplier/listItem.vue
// module id = null
// module chunks = 